import { BaseModel } from "@/models/base.model"
import type { IProductionStatementApprovalAllocation } from "@/interfaces/api/production-statement-approval-allocation.interface"

export class ProductionStatementApprovalAllocation
  extends BaseModel
  implements IProductionStatementApprovalAllocation
{
  public static className = "ProductionStatementApprovalAllocation"
  public static verboseName = "Toewijzing klantakkoord"

  productionStatement: string
  productionStatementApproval: string
  productionStatementApprovalReference?: string
  amount: string

  constructor(allocation: IProductionStatementApprovalAllocation) {
    super(allocation)

    this.productionStatement = allocation.productionStatement
    this.productionStatementApproval = allocation.productionStatementApproval
    this.productionStatementApprovalReference = allocation.productionStatementApprovalReference
    this.amount = allocation.amount
  }
}
